import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-787bd85c")

_pushScopeId("data-v-787bd85c")
const _hoisted_1 = { class: "project" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = {
  key: 0,
  class: "figma"
}
const _hoisted_4 = {
  key: 1,
  class: "gallery"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "pics"
}
const _hoisted_7 = {
  key: 1,
  class: "break"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageItem = _resolveComponent("ImageItem")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("header", _hoisted_2, [
      _createVNode("h1", null, _toDisplayString(_ctx.project.title), 1),
      _createVNode("p", null, _toDisplayString(_ctx.project.description), 1)
    ]),
    (_ctx.project.figmaUrl)
      ? (_openBlock(), _createBlock("section", _hoisted_3, [
          _createVNode("iframe", {
            style: {"border":"1px solid rgba(0, 0, 0, 0.1)"},
            width: "100%",
            height: "700",
            src: _ctx.project.figmaUrl,
            allowfullscreen: ""
          }, null, 8, ["src"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.images.length > 0)
      ? (_openBlock(), _createBlock("section", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
            return (_openBlock(), _createBlock("div", {
              style: { background: image.bgColor },
              class: image.class,
              key: index
            }, [
              (image.name)
                ? (_openBlock(), _createBlock("div", _hoisted_5, [
                    (!image.pics)
                      ? (_openBlock(), _createBlock(_component_ImageItem, {
                          key: 0,
                          class: "project-img",
                          id: `img-${index}`,
                          source: _ctx.getImgUrl(image.fileName),
                          alt: image.name,
                          imageStyle: 'border-radius: 4px;' + image.style
                        }, null, 8, ["id", "source", "alt", "imageStyle"]))
                      : _createCommentVNode("", true),
                    (image.pics)
                      ? (_openBlock(), _createBlock("div", _hoisted_6, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(image.pics, (pic) => {
                            return (_openBlock(), _createBlock(_component_ImageItem, {
                              class: "project-img",
                              key: pic,
                              source: _ctx.getImgUrl(pic),
                              alt: image.name,
                              imageStyle: 'border-radius: 4px;' + image.style
                            }, null, 8, ["source", "alt", "imageStyle"]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true),
              (image.break)
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("h1", null, _toDisplayString(image.break), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 6))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
})